<template>
  <div>
    <second-page
      :asideTitle="asideTitle"
      :title="title"
      :currPrograma="currPrograma"
      :asideList="asideList"
      :currType="currType"
      :currPath="currPath"
      :routeKeepAlive="routeKeepAlive"
      :routeKeepChild="routeKeepChild"
      @titleChange="titleChange"
      @currProgramaChange="currProgramaChange"
      @currTypeChange="currTypeChange"
    ></second-page>
  </div>
</template>
<script>
import SecondPage from '../../components/SecondPage/index.vue'
export default {
  name: 'union',
  components: {
    SecondPage,
  },
  data() {
    return {
      asideTitle: '工会工作',
      title: '',
      currPrograma: '',
      asideList: [
        {
          id: 0,
          title: '学校工会',
          child: [],
          showType: 'list',
        },
        {
          id: 1,
          title: '部门工会',
          child: [],
          showType: 'list',
        },
      ],
      currType: 'list',
      currPath: '/union',
      routeKeepAlive: '',
      routeKeepChild: '',
    }
  },
  created() {
    this.routeKeepAlive = this.$route.query.keepalive
    this.routeKeepChild = this.$route.query.keepchild
  },
  methods: {
    titleChange(currVal) {
      this.title = currVal
    },
    currProgramaChange(currVal) {
      this.currPrograma = currVal
    },
    currTypeChange(currVal) {
      this.currType = currVal
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  width: 1100px;
  margin-left: calc(50% - 550px);
}
</style>
